export const NotificationPositionMap: Record<string, "top" | "bottom"> = {
  top: "top",
  "top-left": "top",
  "top-right": "top",
  bottom: "bottom",
  "bottom-left": "bottom",
  "bottom-right": "bottom",
};
